import { FooterWrapper } from './FooterStyle';

const Footer = () => {
  return (
    <FooterWrapper>
      copyrights reserved &copy; 2024 to <a href="https://echosoft-tech.com">echo soft</a>
    </FooterWrapper>
  )
}

export default Footer